export default __webpack_public_path__ + "static/media/bg.806c4ee6.png";